import React, { Component } from 'react'
import { toast } from 'react-toastify';
import Select from 'react-select';

import { updCalif, ConsultCalif } from '../../../funciones/CalifFunction';

class EstudiantesTableCalifDir extends Component {
    state = {
        preloader:{
            icon: "fa fa-circle",
            color: "#9A9A9A" 
        },
        nota: "",
        disabled: true,
        literalesC: [],
        literalSelect: { value: "", label: "- Selecciona -" }
    }

    constructor (props) {
        super (props);
        if (this.props.cuantitativo === 1){
            ConsultCalif (this.props.seccion, this.props.est.id_estudiante, this.props.corte,(resp) => {
                if (resp < 10) resp = `0${resp}`;
                if (resp === "0") resp = "";
                this.setState({
                    nota: resp,
                    disabled: false,
                })
            })
        }else{
            ConsultCalif (this.props.seccion, this.props.est.id_estudiante, this.props.corte,(resp) => {
                if (resp[0] != null){
                    const lit = (this.state.literalesC).find(option => option.value === parseInt(resp[0]));
                    this.setState({
                        literalSelect: lit,
                        disabled: false,
                    })
                }else{
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
    }

    componentDidMount = () => {
        if (this.props.cuantitativo === 0){
            let contenido = [];
            (this.props.literales).forEach(option => {
                contenido.push({
                    value: option.id, label: option.literal
                })
            });

            this.setState({literalesC: contenido})
        }
    }

    componentWillReceiveProps = (props) => {
        if (this.props.cuantitativo === 1){
            ConsultCalif (props.seccion, props.est.id_estudiante, props.corte,(resp) => {
                if (resp < 10) resp = `0${resp}`;
                if (resp === "0") resp = "";
                this.setState({
                    nota: resp,
                    preloader:{
                        icon: "fa fa-circle",
                        color: "#9A9A9A" 
                    },
                    disabled: false,
                })
            })
        }else{
            ConsultCalif (this.props.seccion, this.props.est.id_estudiante, this.props.corte,(resp) => {
                if (resp[0] != null){
                    const lit = (this.state.literalesC).find(option => option.value === parseInt(resp[0]));
                    this.setState({
                        literalSelect: lit,
                        disabled: false,
                    })
                }else{
                    this.setState({
                        disabled: false
                    })
                }
            })
        }
    }

    disabled = () => {
        if (this.props.corte === "") return true;
        return false
    }

    tabEnter = () => (e) => {
        if (e.which === 13){
            let next = this.props.num + 1;
            if (document.getElementById(`nota_${next}`) === null) next = this.props.num - 1;;
            document.getElementById(`nota_${next}`).focus();
        };
    }

    textBlur = () => (e) => {
        let { corte, est, seccion } = this.props;
        let { nota } = this.state;
        if (this.state.nota === "") return null;

        this.setState({
            preloader:{
                icon: "fa fa-circle-o-notch fa-spin",
                color: "#9A9A9A" 
            }
        }, () => {
            updCalif( nota, corte.substr(4), est.id_estudiante, seccion,
                (resp) => {
                    if (resp[1].status !== "") toast[resp[1].status](resp[1].mensaje,{autoClose: 4000});
                    this.setState({
                        nota: resp[0],
                        preloader: resp[2]
                    })
                }
            )
        })
    }

    cambiaValor = () => (event) => {
        this.setState({
            nota:(event.target.value).toUpperCase()
        });
    };

    cambiarNota = (literalSelect) => {
        let { corte, est, seccion } = this.props;
        this.setState({
            literalSelect,
            preloader:{
                icon: "fa fa-circle-o-notch fa-spin",
                color: "#9A9A9A" 
            }
        }, () => {
            updCalif(literalSelect.value, corte.substr(4), est.id_estudiante, seccion,
                (resp) => {
                    if (resp[1].status !== "") toast[resp[1].status](resp[1].mensaje,{autoClose: 4000});
                    this.setState({
                        preloader: resp[2]
                    })
                }
            )
        })
    }

    notaText = () => {
        let { cuantitativo } = this.props;
        let {literalesC, literalSelect, disabled} = this.state;

        if (cuantitativo === 1) return (
            <input id = {`nota_${this.props.num}`} type="text" onKeyPress={this.tabEnter()} onChange={this.cambiaValor()} value={this.state.nota} onBlur={this.textBlur()} disabled={this.state.disabled} className="form-control" maxLength={3}/>
        )

        const customStyles = {
            option: (provided) => ({
              ...provided,
              fontSize: 10
            }),
        }

        return (
            <Select
                isDisabled={disabled}
                styles={customStyles}
                isSearchable = {true}
                value={literalSelect}
                onChange={this.cambiarNota}
                options={literalesC}
            />
        )
    }

    render() { 
        let { est, estErr } = this.props;
        let estilos = {};

        if (estErr.includes(`${est.nacionalidad} ${est.ci}`) === true) {
            estilos = {
                backgroundColor: "#FAF4F4",
                color: "#A0555C"
            };
        }

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre2 = "";
        let apellido2 = "";
        (est.nombre_2 === null) ? nombre2 = "" : nombre2 = est.nombre_2;
        (est.apellido_2 === null) ? apellido2 = "" : apellido2 = est.apellido_2;

        let nombre = `${est.apellido_1} ${apellido2} ${est.nombre_1} ${nombre2}`;

        return (
            <React.Fragment>
                <tr style={estilos}>
                    <td style={{padding: 0, fontSize: 12}} width="10px" align="center"><strong>{this.props.num}</strong></td>
                    <td style={styles} width="50px">{`${est.nacionalidad} ${est.ci}`}</td>
                    <td style={styles}>{nombre}</td>
                    <td style={styles} align= "center">
                        {this.notaText()}
                    </td>
                    <td style={styles} width="7px" align= "center"><i className={this.state.preloader.icon} style={{color: this.state.preloader.color}}></i></td>
                </tr>
            </React.Fragment>
        );
    }
}
 
export default EstudiantesTableCalifDir;


// WEBPACK FOOTER //
// ./src/views/Academicos/CalificacionesContent/EstudiantesTableCalifDir.jsx